export default "__VITE_ASSET__BY8pGeRE__"